import { Navigate, Routes, Route } from "react-router-dom";

import ROUTES from "@app/common/routes";

import {
  USER_SETTINGS_ROUTE_MIGRATIONS,
  USER_SETTINGS_ROUTES,
} from "./constants";
import UserPreferences from "./UserPreferences";

const getRelativePath = (route: string) =>
  route.replace(ROUTES.USER_SETTINGS_ROOT, "");

const UserPreferencesRoutes = () => (
  <Routes>
    {USER_SETTINGS_ROUTES.map(({ route, sectionId }) => (
      <Route
        key={route}
        path={getRelativePath(route)}
        element={<UserPreferences sectionId={sectionId} />}
      />
    ))}
    {USER_SETTINGS_ROUTE_MIGRATIONS.map(({ oldPath, newPath }) => (
      <Route
        key={oldPath}
        path={getRelativePath(oldPath)}
        element={<Navigate to={newPath} replace />}
      />
    ))}
    <Route
      path="*"
      element={<Navigate to={ROUTES.USER_SETTINGS_DEFAULT_SECTION} replace />}
    />
  </Routes>
);

export default UserPreferencesRoutes;
